import React, { forwardRef } from 'react'
import s from './index.module.scss'

interface IProps extends React.HTMLProps<HTMLInputElement> {
	label: string
}

const CheckboxSwitcher = forwardRef<HTMLInputElement, IProps>(({ label, ...props }, ref) => {
	return (
		<label className={s.wrapper}>
			<input ref={ref} type="checkbox" className={s.input} {...props} />

			<span className={s.sliderWrapper}>
				<span className={s.label}>{label}</span>
				<span className={s.slider}></span>
			</span>
		</label>
	)
})

CheckboxSwitcher.displayName = 'CheckboxSwitcher'

export default CheckboxSwitcher
